import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@emotion/react';
import { GlobalStyles } from './services/configuration/theme/reset';
import { appTheme } from './services/configuration/theme/theme';
import './services/configuration/i18n/i18n';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './services/configuration/store/store';
import moment from 'moment';

moment.locale('en', {
  week: {
    dow: 1,
  },
});
moment.locale('en');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={appTheme}>
          <GlobalStyles />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

/**
 * Prosty checker wersji:
 * - odczytuje /version (tworzone w obrazie jako version.txt)
 * - jeśli treść różni się od poprzednio zapisanej, robi twardy reload
 */
const VERSION_STORAGE_KEY = 'app_version';
const RELOAD_ONCE_FLAG = 'reloaded_for_new_version';

async function checkAppVersionOnce() {
  try {
    const res = await fetch('/version', { cache: 'no-store' });
    if (!res.ok) return;

    const txt = (await res.text()).trim();
    const prev = localStorage.getItem(VERSION_STORAGE_KEY);

    if (prev && prev !== txt) {
      // zapisz NOWĄ wersję ZANIM zrobisz reload
      localStorage.setItem(VERSION_STORAGE_KEY, txt);

      // zabezpieczenie: odśwież tylko raz na sesję
      if (!sessionStorage.getItem(RELOAD_ONCE_FLAG)) {
        sessionStorage.setItem(RELOAD_ONCE_FLAG, '1');
        window.location.reload();
      }
      return;
    }

    // pierwsze uruchomienie albo wersja bez zmian
    if (!prev) localStorage.setItem(VERSION_STORAGE_KEY, txt);
  } catch {
    // brak wersji nie powinien psuć działania
  }
}

// 1) sprawdź od razu po starcie
checkAppVersionOnce();

// 2) sprawdź przy powrocie do zakładki (np. po deployu w międzyczasie)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    checkAppVersionOnce();
  }
});

// CRA vitals
reportWebVitals();
